<template>
  <!-- begin:: Header -->
  <div
    id="kt_header"
    ref="kt_header"
    class="header"
    v-bind:class="headerClasses"
  >
    <div
      class="container-fluid d-flex align-items-right justify-content-between"
    >
      <!-- begin:: Header Menu -->
      <div
        class="header-menu-wrapper header-menu-wrapper-left col p-0 align-self-center"
        ref="kt_header_menu_wrapper"
      >
        <div class="row align-items-center">
          <div class="col-auto">
            <h6
              class="mb-0 font-weight-bolder align-items-center"
              v-html="currentUserPersonalInfo.cliente"
            ></h6>
            <p class="mb-0" v-if="currentUserPersonalInfo.conta">
              <span class="font-weight-bolder">Conta:</span>
              {{ currentUserPersonalInfo.conta }}
            </p>
            <p class="mb-0" v-if="currentUserPersonalInfo.emailCliente">
              <span class="font-weight-bolder">Email:</span>
              {{ currentUserPersonalInfo.emailCliente }}
            </p>
          </div>

          <div
            class="col-auto"
            v-if="
              (checkSuperAdmin || isAccountAdmin) && contasParaTroca.length > 0
            "
          >
            <button
              @click="trocarUsuarioOuConta"
              class="btn btn-wellon-branco btn-sm"
            >
              <i class="fas fa-arrow-right-arrow-left"></i>
              Trocar Conta
            </button>
          </div>
        </div>
      </div>
      <!-- end:: Header Menu -->

      <KTTopbar></KTTopbar>
    </div>

    <b-modal
      ref="mdlTrocarUsuarioOuConta"
      title="Trocar Conta"
      @hidden="limpar"
      @ok="trocarConta"
      okVariant="success"
      okTitle="Trocar"
      cancelTitle="Cancelar"
      v-if="(checkSuperAdmin || isAccountAdmin) && contasParaTroca.length > 0"
      hide-footer
    >
      <div>
        <b-button
          variant="outline-dark"
          block
          @click="trocarParaSuperAdmin"
          v-if="checkSuperAdmin && hasAccount"
          class="mb-4"
          >Trocar para Administrador do Sistema
          <i class="fas fa-star text-info ml-2"></i
        ></b-button>

        <p>Selecione uma conta da lista a seguir:</p>

        <b-form-input
          v-model="filtroContas"
          placeholder="Digite para filtrar..."
          @input="filtrarContas"
          class="mb-2"
        ></b-form-input>

        <ul class="navi navi-hover navi-active">
          <li class="navi-item" v-for="conta in contas" :key="conta.id">
            <a
              class="navi-link text-hover-warning"
              href="javascript:;"
              @click.prevent="trocarConta(conta.id)"
            >
              <div class="navi-text">
                <span class="d-block font-weight-bold">{{ conta.login }}</span>
                <span class="text-muted">{{ conta.nome }}</span>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </b-modal>
  </div>
  <!-- end:: Header -->
</template>

<script>
import { mapGetters } from "vuex";
import KTTopbar from "@/view/layout/header/Topbar.vue";
import KTLayoutHeader from "@/assets/js/layout/base/header.js";
import ApiService from "../../../core/services/api.service";
import Swal from "sweetalert2";

export default {
  name: "KTHeader",
  components: {
    KTTopbar
  },
  data() {
    return {
      contas: [],
      idContaSelecionada: null,
      filtroContas: ""
    };
  },
  mounted() {
    // Init Desktop & Mobile Headers
    KTLayoutHeader.init("kt_header", "kt_header_mobile");
  },
  computed: {
    ...mapGetters([
      "getClasses",
      "currentUserPersonalInfo",
      "hasAccount",
      "isAccountAdmin",
      "contasParaTroca",
      "checkSuperAdmin",
      "isAdmin"
    ]),

    /**
     * Get extra classes for header based on the options
     * @returns {null|*}
     */
    headerClasses() {
      const classes = this.getClasses("header");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    }
  },

  methods: {
    trocarUsuarioOuConta() {
      this.contas = [...this.contasParaTroca];
      this.$refs["mdlTrocarUsuarioOuConta"].show();
    },

    filtrarContas(filtro) {
      if (filtro.length > 0) {
        this.contas = this.contasParaTroca.filter(
          (conta) => conta.login.includes(filtro) || conta.nome.includes(filtro)
        );
      } else {
        this.contas = [...this.contasParaTroca];
      }
    },

    limpar() {
      this.idContaSelecionada = null;
      this.contas = [];
      this.filtroContas = "";
    },

    trocarConta(conta) {
      Swal.fire({
        title: "Deseja realmente trocar para a conta selecionada?",
        showCancelButton: true,
        confirmButtonText: "Trocar",
        cancelButtonText: "Cancelar",
        customClass: {
          cancelButton: "btn btn-secondary",
          confirmButton: "btn btn-success"
        },
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {
          ApiService.post("/usuario/trocar-conta", {
            contaId: conta
          }).then(() => {
            window.location.href = "/";
          });
        }
      });
    },

    trocarParaSuperAdmin() {
      Swal.fire({
        title:
          "Deseja realmente trocar o usuário para Administrador do Sistema?",
        showCancelButton: true,
        confirmButtonText: "Trocar",
        cancelButtonText: "Cancelar",
        customClass: {
          cancelButton: "btn btn-secondary",
          confirmButton: "btn btn-info"
        },
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {
          ApiService.get("/usuario/trocar-para-super-admin").then(() => {
            window.location.href = "/";
          });
        }
      });
    },

    obterIdContaSelecionada(obj) {
      this.idContaSelecionada = obj ? obj.id : null;
    }
  }
};
</script>
